import { useAddUser } from "../hooks/UserHooks";
import { UserDTO } from "../types/userDTO";
import ValidationSummary from "../ValidationSummary";
import UserForm from "./UserForm";
import { toast } from 'react-toastify';
import { ClipLoader } from "react-spinners";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { useState } from "react";

const UserAdd = () => {
  const { t } = useTranslation();
  const createValidToDate = () => {
    const date = new Date();
    date.setFullYear(2099);
    date.setSeconds(0, 0);
    return date;
  };
  const { organisationId } = useParams<{ organisationId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  const [userState, setUserState] = useState<UserDTO>({
    id: "00000000-0000-0000-0000-000000000000",
    organisationId: organisationId,
    userName: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    validFrom: new Date(new Date().setSeconds(0, 0)),
    validTo: createValidToDate(),
    lastModified: new Date(),
    roles: [],
      capabilities: [],
      userGroups: [],
    stations: [],
    isLocked: false,
    language: "Finnish"
  });
  const addUserMutation = useAddUser(organisationId, setUserState);


  return (
    <>
      {addUserMutation.isError && (
        <ValidationSummary error={addUserMutation.error} />
      )}
      {addUserMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('user.addWait')}</p>
        </div>
      ) : (
        <UserForm
          headerText={t('user.add')}
          user={userState}
          submitted={(user) => addUserMutation.mutate(user, {
            onSuccess: () => {
              toast.success(t('user.addSuccess'));
              history.back();
            },
            onError: () => {
              toast.error(t('user.addError'));
            }
          })}
        />
      )}
    </>
  );
};

export default UserAdd;